import { API_URL } from "config";
import Notify from "config/notify";
import Http from "util/https";

type Arg = {
  mode: 0 | 1;
}

/**
 * アップロードしたCSVを反映
 * @param process_id プロセスID
 */
export async function emailReceiveSettingApi({mode}: Arg) {
  const http = Http.default.alterAuth({ useToken: true });
  // const url = `${API_URL}/order/vendor/email/publish`;
  const url = `${API_URL}/order/receiving/setting`;
  const res = await http.post(url, { receiving_setting: mode });
  console.log(res);

  // await new Promise<void>((resolve) => {setTimeout(resolve, 1500)});

  // const res = {status: 200};
  // if (res.status === 200) {
  //   Notify.setNotification({
  //     show: true,
  //     title: "設定しました。",
  //     confirmLabel: "OK",
  //     actionsPosition: "end",
  //   });
  // }
}

/**
 * 現在のメール設定値を取得
 */
export async function getEmailReceiveSettingApi() {
  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/order/receiving/setting`;
  const res = await http.post<{receiving_setting: 0 | 1}>(url, {});
  // await new Promise<void>((resolve) => {setTimeout(resolve, 1500)});
  // const res: {data: {mode: 0 | 1}} = {data: {mode: 1}};
  console.log(res)
  return {
    mode: res.data.receiving_setting
  }
}
